export const CUSTOMERS_EMAIL = "ayuda@hadamenu.com";
export const INSTAGRAM_URL = "https://www.instagram.com/hadamenu/";
export const FACEBOOK_URL = "https://www.facebook.com/hadamenuofficial/";

export const LANGUAGES = {
  en: { nativeName: "English" },
  es: { nativeName: "Spanish" },
} as const;
